import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
import { ShieldAlert } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-[90vh] flex items-center pt-20 pb-16 overflow-hidden bg-tactical-dark border-b border-tactical-border" data-id="element-84">
      {/* Background elements */}
      <div className="absolute inset-0 bg-grid-pattern opacity-20 pointer-events-none" data-id="element-85"></div>
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-[500px] bg-tactical-accent/10 blur-[120px] rounded-full pointer-events-none" data-id="element-86"></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-87">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-88">
          {/* Text Content */}
          <div className="max-w-2xl" data-id="element-89">
            <FadeIn data-id="element-90">
              <div className="inline-flex items-center gap-2 px-3 py-1 bg-zinc-900 border border-tactical-border text-tactical-accent font-mono text-xs sm:text-sm uppercase tracking-widest mb-6" data-id="element-91">
                <ShieldAlert className="w-4 h-4" data-id="element-92" />
                <span data-id="element-93">[ Sistema de Emergencia ]</span>
              </div>
            </FadeIn>

            <FadeIn delay={0.1} data-id="element-94">
              <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold uppercase leading-[1.1] mb-6 text-shadow-tactical" data-id="element-95">
                Protocolo <br data-id="element-96" />
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-zinc-100 to-zinc-500" data-id="element-97">
                  Actuar es Ganar
                </span>
              </h1>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-98">
              <h2 className="text-xl sm:text-2xl text-zinc-400 font-oswald uppercase tracking-wide mb-6 border-l-4 border-tactical-accent pl-4" data-id="element-99">
                El Sistema de Emergencia para el Hispano en USA que decidió no
                volver a perder.
              </h2>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-100">
              <p className="text-lg text-zinc-300 mb-8 leading-relaxed" data-id="element-101">
                Deja de planificar tu vida y empieza a ejecutarla: Cómo pasar de
                la parálisis mental a resultados físicos y financieros en solo
                21 días.
              </p>
            </FadeIn>

            <FadeIn delay={0.4} data-id="element-102">
              <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center" data-id="element-103">
                <Button variant="primary" data-id="element-104">Iniciar Protocolo Ahora</Button>
                <div className="flex items-center gap-2 text-sm font-mono text-zinc-500 uppercase" data-id="element-105">
                  <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse" data-id="element-106"></span>
                  Acceso Inmediato
                </div>
              </div>
            </FadeIn>
          </div>

          {/* Image */}
          <FadeIn delay={0.3} direction="left" className="relative" data-id="element-107">
            <div className="relative aspect-square max-w-md mx-auto lg:max-w-none" data-id="element-108">
              {/* Decorative corners for image */}
              <div className="absolute -inset-4 border border-tactical-border bg-tactical-panel/50 z-0 hidden sm:block" data-id="element-109">
                <div className="absolute top-0 left-0 w-4 h-4 border-t-2 border-l-2 border-tactical-accent" data-id="element-110"></div>
                <div className="absolute top-0 right-0 w-4 h-4 border-t-2 border-r-2 border-tactical-accent" data-id="element-111"></div>
                <div className="absolute bottom-0 left-0 w-4 h-4 border-b-2 border-l-2 border-tactical-accent" data-id="element-112"></div>
                <div className="absolute bottom-0 right-0 w-4 h-4 border-b-2 border-r-2 border-tactical-accent" data-id="element-113"></div>
              </div>

              <img src="https://cdn.magicpatterns.com/uploads/cTekaqGF1ux7U5h49hYbCV/PROTOLOGO_ACTUAR_ES_GANAR.png" alt="Protocolo Actuar Es Ganar Bundle" className="relative z-10 w-full h-full object-cover shadow-2xl shadow-black/50 filter contrast-125 saturate-50" data-id="element-114" />

              {/* Overlay gradient to blend image slightly */}
              <div className="absolute inset-0 bg-gradient-to-tr from-tactical-dark/40 to-transparent z-20 pointer-events-none" data-id="element-115"></div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}